import { partnerCompanyDto } from './../api/company';
/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  getters.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:27
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import {flattenTree} from "@/utils/util";

const getters = {
  token: (state: any) => state.user.token,
  mobile: (state: any) => state.user.mobile,
  password: (state: any) => state.user.password,
  userId: (state: any) => state.user.userId,
  roles: (state: any) => state.user.roles,
  flattenRoles: (state: any) => flattenTree(state.user.roles), // 展平之后的菜单树
  info: (state: any) => state.user.info,
  addRouters: (state: any) => state.permission.addRouters,
  includedComponents: (state: any) => state.app.includedComponents,
  isFullMode: (state: any) => state.app.isFullMode,
  providerId: (state: any) => state.app.providerId, // 企业商城店铺编号
  preOrderParams: (state: any) => state.shoppingMall.preOrderParams, // 获取预提交订单信息入参数据
  preReturnOrderParams: (state: any) => state.shoppingMall.preReturnOrderParams, // 获取预提交退单信息入参数据
  orderDtl: (state: any) => state.shoppingMall.orderDtl, // 套餐清单列表
  returnOrderDtl: (state: any) => state.shoppingMall.returnOrderDtl, // 退货套餐清单列表
  companyId: (state: any) => state.user.info?.companyId, // 进入公司编号
  companyName: (state: any) => state.user.info.companyName, // 进入公司名称
  logoUrl: (state: any) => state.user.info.logoUrl, // 公司头像
  selectList: (state: any) => state.order.selectList, // 代客下单选择商品页选种商品缓存数据
  shareInfo: (state: any) => state.share, // 分享模块数据
  messageUnreadNo: (state: any) => state.order.messageUnreadNo, // 未读消息条数
  loading: (state: any) => state.app.loading, // 当前正在请求的接口数量==>控制loading是否显示
  partnerCompanyId: (state: any) => state.user.info.partnerCompanyId, // 合作方公司id
  whiteStrips: (state: any) => state.user.whiteStrips, // 金融权限
  routerAliveStatus: (state:any) => state.app.routerAliveStatus, // 无感刷新路由
  safetyHeight: (state:any) => state.app.safetyHeight, // 手机底部安全高度
  topSafetyHeight: (state:any) => state.app.topSafetyHeight, // 手机顶部安全高度
  bottomSafetyHeight: (state:any) => state.app.bottomSafetyHeight, // 手机底部安全高度
  tabModules: (state:any) => state.app.tabModules, // 手机底部安全高度
  isAgreeMessageProtect: (state: any) => state.app.isAgreeMessageProtect, // 是否同意个人信息保护提示
  isMultiStore: (state: any) => state.app.isMultiStore, // 是否多店总览模式
  multiStoreList: (state: any) => state.app.multiStoreList, // 多店总览选中的店铺列表
  keepAlivePages: (state: any) => state.app.keepAlivePages, // 保持活动页面
  sendSmsCodeTimes: (state: any) => state.app.sendSmsCodeTimes, // 发送验证码时间数组
  aiSourceUrl: (state: any) => state.app.aiSourceUrl // ai访问地址
};

export default getters;
